import axios, {AxiosInstance, AxiosResponse} from 'axios';
import type {RiddleData} from 'entities';
import type {MessagesType} from 'src/lib/translates/types'
import type {ResponseLettersType} from './letters/entities'

type CommonType = RiddleData
    | MessagesType
    | ResponseLettersType ;

export type ResponseType<T> = {
    result: T;
    errors?: string[];
}

export type InitProps = {
    messages?: MessagesType;
    prefix?: string;
    apiVersion?: string;
}

export type InstanceApi = AxiosInstance

export class APIService {
    prefixDefault = '';
    apiVersionDefault = '/api/v1';
    messagesDefault: MessagesType = {
        ERROR_UNEXPECTED: 'ERROR_UNEXPECTED',
        ERROR_OFFLINE: 'ERROR_OFFLINE',
        DEFAULT: 'DEFAULT',
    };
    messages: MessagesType = this.messagesDefault
    prefix: string = this.prefixDefault
    apiVersion: string = this.apiVersionDefault
    axiosInner: AxiosInstance | null = null

    constructor({messages, prefix, apiVersion}: InitProps) {
        this.messages = messages ?? this.messages
        this.prefix = prefix ?? this.prefix
        this.apiVersion = apiVersion ?? this.apiVersion
        this.init()
    }
    
    private init() {
        const baseURL = `${this.apiVersion}${this.prefix}`;

        this.axiosInner = axios.create({
            baseURL,
        });

        this.axiosInner.interceptors.response.use((response: AxiosResponse<ResponseType<CommonType>>) => {
            if (response.data.errors) {
                throw new Error(this.formatErrors(response.data.errors));
            }

            return response;
        }, (err) => {
            let errorMessage = this.messages.ERROR_UNEXPECTED;
            if (err.message) {
                const regExp = /(network( )?error)/gi;
                const isNetworkError = regExp.test(err.message);
                if (isNetworkError) {
                    errorMessage = this.messages.ERROR_OFFLINE;
                }
            }
            if (err.response?.status >= 500) {
                errorMessage = this.messages.DEFAULT;
            }
            if (err.response?.status === 400) {
                errorMessage = this.formatErrors(err.response.data.errors);
            }
            if (err.response?.status === 409) {
                errorMessage = 'CONFLICT'
            }
            throw new Error(errorMessage);
        });

        return this.axiosInner;
    }

    formatErrors(errors: string[]) {
        return errors.join('. ') + (errors.length > 1 ? '.' : '');
    }

    public getInstanse() {
        return this.axiosInner ?? axios.create({baseURL: ''});
    }
}
